export * from './aDSync.service';
import { ADSyncService } from './aDSync.service';
export * from './agent.service';
import { AgentService } from './agent.service';
export * from './version.service';
import { VersionService } from './version.service';
export const APIS = [ADSyncService, AgentService, VersionService];
